import { render, staticRenderFns } from "./Bankscb.vue?vue&type=template&id=0a19e497"
import script from "./Bankscb.vue?vue&type=script&lang=js"
export * from "./Bankscb.vue?vue&type=script&lang=js"
import style0 from "./Bankscb.vue?vue&type=style&index=0&id=0a19e497&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports